import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const Email1FormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='EMAIL 1' htmlFor='input-email1' md={2} />
      <Col md={10}>
        <Field name='email1'>
          {({ field }) => (
            <Form.InputEmail
              {...field}
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
              id='input-email1'
              placeholder='Ingresar email ...'
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(Email1FormGroup)
